import { StateType } from 'src/redux/reducers';

export const notificationsSelector = ({ notifications }: StateType) => notifications;
